export const DEFAULT_ENROLLMENT_HOUR = 10;
